module.exports = __webpack_public_path__ + "img/ZGHT.1b4aac68.png";